function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M38.484 4.607c2.007-3.476 7.024-3.476 9.03 0l35.522 61.525c2.007 3.476-.501 7.821-4.515 7.821H7.478c-4.014 0-6.523-4.345-4.516-7.82L38.484 4.606z",
  fill: "#FFF6E9"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.45 24.988L47.529 4.584c-2.019-3.456-7.016-3.443-9.017.023L2.962 66.179C.955 69.655 3.464 74 7.478 74H78.52c4.014 0 6.522-4.345 4.515-7.821L69.49 42.716",
  stroke: "#FFA825",
  strokeWidth: 3.5,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 42.809,
  cy: 57.074,
  r: 1.969,
  transform: "rotate(-180 42.809 57.074)",
  fill: "#FFA825"
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 44.777,
  y: 50.629,
  width: 3.937,
  height: 20.473,
  rx: 1.969,
  transform: "rotate(-180 44.777 50.629)",
  fill: "#FFA825"
});
function SvgIcoWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 76,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}
export default __webpack_public_path__ + "/img/ico-warning.svg";
export { SvgIcoWarning as ReactComponent };